import type { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'

class CollapsedTags extends BaseComponent {
  hiddenTags: Nullable<HTMLElement>
  visibleTags: Nullable<HTMLElement>
  tags: HTMLElement[]
  extendButton: Nullable<HTMLElement>

  resizeObserver: ResizeObserver

  constructor() {
    super()

    this.visibleTags = this.querySelector('[data-visible-tags]')
    this.hiddenTags = this.querySelector('[data-collapsed-tags]')
    this.tags = [...this.querySelectorAll('[data-tag]')] as HTMLElement[]
    this.extendButton = this.querySelector('[data-extend-button]')

    this.resizeObserver = new ResizeObserver(this.handleContentResize)
    this.resizeObserver.observe(this)
  }

  connectedCallback(): void {
    this.initOffsets()

    this.update()
  }

  disconnectedCallback(): void {
    this.resizeObserver.disconnect()
  }

  handleContentResize = (): void => {
    this.update()
  }

  updateButtonVisible(): void {
    if (!this.extendButton) {
      return
    }

    const hiddenTags = this.querySelectorAll('[tag-hidden]')
    const hasHiddenTags = hiddenTags.length > 0

    this.extendButton.classList.toggle('hidden', !hasHiddenTags)

    this.toggleAttribute('data-is-collapsed', !hasHiddenTags)
  }

  initOffsets(): void {
    this.tags.forEach(tag => {
      tag.style.left = `${tag.offsetLeft}px`
      tag.style.top = `${tag.offsetTop}px`
    })
  }

  updateTagsVisible(): void {
    const collapsedTagsFragment = document.createDocumentFragment()
    const extendButtonWidth = this.extendButton?.offsetWidth || 0

    const visibleTags = this.tags.filter(tag => !tag.hasAttribute('tag-hidden'))
    const lastVisibleTag = visibleTags[visibleTags.length - 1]

    this.tags.forEach(tag => {
      const tagRightPosition = tag.offsetLeft + tag.offsetWidth

      const maxWidth =
        this.offsetWidth - extendButtonWidth - lastVisibleTag.offsetWidth
      const isOverflowed = tagRightPosition > maxWidth

      if (isOverflowed) {
        const clone = tag.cloneNode(true)

        this.setTagVisible(clone, true)

        collapsedTagsFragment.appendChild(clone)
      }

      this.setTagVisible(tag, !isOverflowed)
    })

    this.hiddenTags?.element.replaceChildren(collapsedTagsFragment)
  }

  setTagVisible(tag: HTMLElement, isVisible: boolean): void {
    tag.toggleAttribute('tag-hidden', !isVisible)
  }

  update(): void {
    this.updateTagsVisible()
    this.updateButtonVisible()
  }
}

export default CollapsedTags
